import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo, useCallback, useEffect, useMemo, useState } from "react";
import { ItemsList, Loading, Typography } from "@parkschannel/ui";
import { Sticker, StickerCard } from "../../Sticker";
import { useInView } from "react-intersection-observer";
import { StickerModal } from "./StickerModal";
import isEqual from "lodash.isequal";
export const UserStickerList = /*#__PURE__*/ memo((param)=>{
    let { data , onItemClick  } = param;
    return /*#__PURE__*/ _jsx(ItemsList, {
        className: "w-full py-6 grid gap-4 sm:grid-cols-2 md:gap-6 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5",
        items: data,
        noItemsMessage: "Parks stickers not found",
        renderItem: (sticker)=>{
            /*#__PURE__*/ return _jsx(StickerCard, {
                data: sticker,
                onClick: (data)=>{
                    return onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick(data);
                }
            });
        }
    });
}, areEqual);
function areEqual(prevProps, nextProps) {
    return isEqual(prevProps, nextProps);
}
export const UserStickerListWithInfinityScroll = (param)=>{
    let { data , hasNextPage , fetchNextPage , isFetchingNextPage  } = param;
    const { ref , inView  } = useInView();
    const [selectedSticker, setSelectedSticker] = useState(null);
    const mergedPages = useMemo(()=>{
        return data.pages.reduce((acc, curr)=>[
                ...acc,
                ...curr.data
            ], []).map((sticker)=>Sticker.fromStickerDTO(sticker));
    }, [
        data
    ]);
    const handleSelectSticker = useCallback((sticker)=>{
        setSelectedSticker(sticker);
    }, []);
    useEffect(()=>{
        if (inView && hasNextPage) {
            fetchNextPage();
        }
    }, [
        inView
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "max-w-full",
        id: "user-parks-section",
        children: [
            /*#__PURE__*/ _jsxs(Typography, {
                variant: "bodyXL",
                className: "text-neutral-600 font-normal mt-10 mb-[26px] !text-[16px]",
                children: [
                    "All stickers provided by Anderson Design Group. To see more, visit",
                    " ",
                    /*#__PURE__*/ _jsx("a", {
                        href: "https://www.andersondesigngroupstore.com",
                        className: "underline",
                        target: "_blank",
                        children: "andersondesigngroupstore.com"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(UserStickerList, {
                data: mergedPages,
                onItemClick: handleSelectSticker
            }),
            /*#__PURE__*/ _jsx("div", {
                ref: ref,
                className: "flex justify-center",
                children: /*#__PURE__*/ _jsx("button", {
                    disabled: !hasNextPage,
                    onClick: ()=>fetchNextPage(),
                    children: isFetchingNextPage ? /*#__PURE__*/ _jsx(Loading, {}) : !hasNextPage ? /*#__PURE__*/ _jsx(Typography, {
                        variant: "captionBase",
                        className: "text-neutral-500",
                        children: "No more to fetch..."
                    }) : /*#__PURE__*/ _jsx(Typography, {
                        variant: "captionBase",
                        className: "text-neutral-900",
                        children: "Load more"
                    })
                })
            }),
            selectedSticker && /*#__PURE__*/ _jsx(StickerModal, {
                isOpen: !!selectedSticker,
                onClose: ()=>setSelectedSticker(null),
                parkId: selectedSticker.parkId
            })
        ]
    });
};
